/*
 * @Descripttion: 
 * @version: 1.0
 * @Author: zhanmei
 * @Date: 2020-08-19 17:39:42
 * @LastEditors: zhanmei
 * @LastEditTime: 2020-08-21 14:28:18
 */
var keyMirror = require('./../../lib/keyMirror');

module.exports = keyMirror({
  APP_STATUS_CHANGE: null,          // app展示状态修改
  INPUT_CHANGE: null,               // 对话框输入文字修改
  PRIVATE_INPUT_CHANGE:null,        //区分群聊 单聊对话框输入文字修改
  KEYBOARD_OUTPUT: null,            // 对话框按键事件输出
  MSG_SEND_APPLY: null,             // 发消息申请
  MSG_RESEND_APPLY: null,           // 重发消息申请
  MSG_SEND_STATUS_CHANGE: null,     // 消息发送状态改变
  MSG_HANDLER_STATUS_CHANGE: null,  // 消息操作状态改变
  MSG_SYNC: null,                   // 消息同步
  MSG_AUDIO_READ: null,             // 语音消息收听
  MSG_AUDIO_READ_START: null,        // 语音播放开始
  MSG_AUDIO_READ_END: null,          // 语音播放完毕
  MSG_AUDIO_ACK_READ: null,          // 语音确认已读
  UNREAD_CHANGE: null,              // 未读信息数量变化
  CONTACT_ONLINE_CHANGE: null,      // 联系人在线状态改变
  LAST_MSG_CHANGE: null,            // 最后一条消息修改（收、发）
  IMAGE_CLICK: null,                // 图片点击
  SESSION_SELF_CHANGE: null,        // 会话自身发生改变
  SESSION_CHILDREN_CHANGE: null,    // 会话下属列表发生改变
  SESSION_CLICK: null,              // 会话点击
  CAPTCHA_SUBMIT: null,             // 验证码提交
  CAPTCHA_CHANGE: null,             // 验证码图片切换
  PERSON_CHECK: null,              // 人员点击
  CREATE_GROUP_CHECK: null,        // 新建群点击
  JOIN_GROUP_CHECK: null,          // 加入群点击
  HIDE_GROUP_WIN: null,           // 隐藏群窗口
  QUIT_GROUP: null,                // 退出群
  DISBAND_GROUP: null,             // 解散群
  GET_GROUP_QRCODE: null,          // 群二维码
  GROUP_NOTICE: null,              // 群公告
  CONFIRM_INVITE: null,            // 群邀请确认
  SES_TOP: null,                   // 置顶
  SET_SILENT: null,                // 免打扰
  SET_GROUP: null,                 // 群设置
  UPDATE_NICKNAME: null,           // 修改群昵称
  UPDATE_GROUPNAME: null,          // 修改群名
  ADD_MEMBER_WIN: null,            // 打开添加群成员窗口
  DELETE_MEMBER_WIN: null,         // 打开删除群成员窗口
  DELETE_MEMBER: null,             // 删除群成员
  AI_SEND: null,                   // 智能客服发送
  FULLSCREEN_OPEN: null,           //全屏打开
  FULLSCREEN_CLOSE: null,          //全屏关闭
  ADD_BLACKLIST: null,             //添加黑名单
  DEL_BLACKLIST: null,             //取消黑名单
  IS_BLACKED_CHECK: null,           // 是否为黑名单
  COMPLAINTS: null,                //举报
  UPLOAD_AUDIT_CHANGE: null,        // 信质审核结果
  FILE_DOWNLOAD: null,              // 文件下载
  FILE_SENDE_CANCEL: null,          // 文件取消发送
  VIDEO_PLAY: null,                  // 视频播放点击
  VIDEO_PLAY_START: null,           // 视频开始播放
  VIDEO_PLAY_PASUED: null,          // 视频暂停播放
  VIDEO_PLAY_END: null,             // 视频结束播放
  VIDEO_PLAY_ERROR: null,            // 视频播放出错
  MSG_INFO_UPDATED: null,            // 消息UI部分更新
  TOAST_SHOW: null,                   // toast提示
  MODAL_WIN_SHOW: null,              // 模态对话框
  CHAT_VIDEO: null,                  // 视频通话
  CHAT_AUDIO: null,                   // 语音通话
  MSG_CLICK: null,                  // 点击消息,
  MSG_ACTION: null,                 // 消息动作
  MSG_WITHDRAW: null ,               // 消息撤回
  SET_EVALUATE:null,                 //评价卡片
  GROUP_At_CONTACTS:null,             // 群成员
  CARD_SEND_MESSAGE: null ,            //通过卡片发送消息
  CLEAR_ALL_UNREAD_MSGS:null,            // 清除所有未读数,
  REPORT_MESSAGES: null,                  // 上报消息  
  SET_USER_REMARK: null,                 // 设置用户备注 
  PROVIDE_CONTACTINFO:null,              //提供用户名片
  SEND_CONTACTINFO: null,                //发送用户名片
  ASK_CONTACTINFO:null,                 //索要用户名片
  GLANCE_CONTACTINFO:null,               //查看用户名片
  GLANCE_CONTACTINFO_RETURN:null,          //查看名片后渲染消息
  GET_SELF_CONTACTINFO:null,              //获取自己的名片信息
  GET_MY_COLLECTION:null,                 //我的收藏
  ADD_COLLECTION:null,                    //收藏消息
  DEL_COLLECTION:null,                        // 删除收藏
  MULTIPLE_FORWARD_WINDOW_OPEN: null,      // 打开选择用户转发窗口
  MULTIPLE_FORWARD_WINDOW_CLOSE: null,      // 关闭选择用户转发窗口
  MULTIPLE_FORWARD_WINDOW_SUBMIT: null,     // 选择用户转发窗口提交
  MULTIPLE_MENU_CLOSE: null,                // 关闭消息多选窗口
  MSG_BATCH_SEND_APPLY: null,                // 批量转发消息
  FORWARD_MESSAGE_FLOAT: null,               // 打开消息记录窗口
  COLLECTION_MESSAGE_FLOAT: null,            // 打开收藏记录窗口
  DEL_MSG: null,                             // 删除消息
  DEL_FALSE_MSGS: null,                      // 删除假消息
  DELETE_TOGETHER: null,                     // 批量删除消息
  CLOSE_ALL_FLOAT_VIEWS: null,               // 关闭所有的消息记录窗口
  STATIC_SEND_MESSAGE: null,                 // 匿名用户发送模版消息
  STATIC_LOGIN: null                         // 匿名用户登录
});
